(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinic-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-testid="clinic-reviews"]').forEach((section) => {
      const track = section.querySelector('[data-reviews-track]');
      const prev = section.querySelector('[data-direction="prev"]');
      const next = section.querySelector('[data-direction="next"]');
      if (!track || !prev || !next) return;

      const scrollByStep = (direction) => {
        const card = track.querySelector('.clinic-reviews__card');
        const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.9;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      };

      prev.addEventListener('click', () => scrollByStep(-1));
      next.addEventListener('click', () => scrollByStep(1));

      const updateButtons = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= max;
      };

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
  const sections = document.querySelectorAll('[data-testid="home-collection"]');
  sections.forEach((section) => {
    const track = section.querySelector('[data-carousel-track]');
    const prev = section.querySelector('[data-direction="prev"]');
    const next = section.querySelector('[data-direction="next"]');
    if (!track || !prev || !next) return;

    const scrollByStep = (direction) => {
      const firstCard = track.querySelector('.home-collection__card');
      const step = firstCard ? firstCard.getBoundingClientRect().width + 16 : track.clientWidth * 0.9;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByStep(-1));
    next.addEventListener('click', () => scrollByStep(1));

    const updateButtons = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    };

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();

    const filters = section.querySelectorAll('.home-collection__filter');
    const cards = section.querySelectorAll('.home-collection__card');

    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        filters.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        const selected = btn.dataset.filter;

        cards.forEach((card) => {
          const tags = (card.dataset.tags || '').split(',');
          const show = selected === 'all' || tags.includes(selected);
          card.style.display = show ? '' : 'none';
        });

        track.scrollTo({ left: 0, behavior: 'instant' });
        updateButtons();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-home-page-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-testid="home-page-collection"]');
    sections.forEach((section) => {
      const filters = section.querySelectorAll('.home-collection__filter');
      const cards = section.querySelectorAll('.home-collection__card');
      if (!filters.length || !cards.length) return;

      filters.forEach((btn) => {
        btn.addEventListener('click', () => {
          filters.forEach((b) => {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          const selected = btn.dataset.filter;
          cards.forEach((card) => {
            const tags = (card.dataset.tags || '').split(',');
            const show = selected === 'all' || tags.includes(selected);
            card.style.display = show ? '' : 'none';
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-minilab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const galleries = document.querySelectorAll('[data-minilab-gallery]');
    galleries.forEach((root) => {
      const slides = Array.from(root.querySelectorAll('.product-minilab__slide'));
      const thumbs = Array.from(root.querySelectorAll('.product-minilab__thumb'));
      const prev = root.querySelector('[data-minilab-prev]');
      const next = root.querySelector('[data-minilab-next]');
      if (slides.length <= 1) return;

      let index = 0;
      const show = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, si) => {
          const active = si === index;
          s.classList.toggle('is-active', active);
          if (active) {
            s.removeAttribute('hidden');
          } else {
            s.setAttribute('hidden', '');
          }
        });
        thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === index));
      };

      prev && prev.addEventListener('click', () => show(index - 1));
      next && next.addEventListener('click', () => show(index + 1));
      thumbs.forEach((t, ti) => t.addEventListener('click', () => show(ti)));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-starter-kit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const galleries = document.querySelectorAll('[data-starter-gallery]');
    galleries.forEach((root) => {
      const slides = Array.from(root.querySelectorAll('.product-starter__slide'));
      const thumbs = Array.from(root.querySelectorAll('.product-starter__thumb'));
      const prev = root.querySelector('[data-starter-prev]');
      const next = root.querySelector('[data-starter-next]');
      if (slides.length <= 1) return;

      let index = 0;
      const show = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, si) => {
          const active = si === index;
          s.classList.toggle('is-active', active);
          if (active) {
            s.removeAttribute('hidden');
          } else {
            s.setAttribute('hidden', '');
          }
        });
        thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === index));
      };

      prev && prev.addEventListener('click', () => show(index - 1));
      next && next.addEventListener('click', () => show(index + 1));
      thumbs.forEach((t, ti) => t.addEventListener('click', () => show(ti)));
    });

    /* Purchase options: toggles the hidden selling_plan input + button price. */
    const purchaseGroups = document.querySelectorAll('[data-purchase-options]');
    purchaseGroups.forEach((group) => {
      const form = group.closest('form');
      const sellingPlanInput = form && form.querySelector('[data-selling-plan-input]');
      const orderPrice = form && form.querySelector('[data-order-price]');
      const inputs = Array.from(group.querySelectorAll('[data-purchase-input]'));
      const rows = Array.from(group.querySelectorAll('[data-purchase-row]'));

      const sync = () => {
        let selected = null;
        rows.forEach((row) => {
          const input = row.querySelector('[data-purchase-input]');
          const isChecked = !!(input && input.checked);
          row.classList.toggle('is-selected', isChecked);
          if (isChecked) selected = input;
        });
        if (!selected) return;

        if (sellingPlanInput) {
          sellingPlanInput.value = selected.dataset.sellingPlanId || '';
        }
        if (orderPrice) {
          const formatted = selected.dataset.priceFormatted;
          if (formatted) orderPrice.textContent = formatted;
        }
      };

      inputs.forEach((input) => input.addEventListener('change', sync));
      sync();
    });

    /* Generic modal system: any element with data-modal-target="<key>" opens
       the sibling dialog with data-modal="<key>" in the same section.
       Liquid is not processed inside section JS blocks, so we look up modals
       via data-attribute rather than by section-id-templated element IDs. */
    document.querySelectorAll('[data-modal-target]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const scope = trigger.closest('.shopify-section') || document;
        const key = trigger.dataset.modalTarget;
        const modal = scope.querySelector('[data-modal="' + key + '"]');
        if (!modal) return;
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
      });
    });

    document.querySelectorAll('[data-modal]').forEach((modal) => {
      modal.querySelectorAll('[data-modal-close]').forEach((btn) => {
        btn.addEventListener('click', () => modal.close());
      });
      /* Click outside the inner panel closes the modal. */
      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-treatment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-treatment-root]').forEach((root) => {
      const slides = Array.from(root.querySelectorAll('.product-treatment__slide'));
      const thumbs = Array.from(root.querySelectorAll('.product-treatment__thumb'));
      const galleryPrev = root.querySelector('[data-treatment-prev]');
      const galleryNext = root.querySelector('[data-treatment-next]');
      const counter = root.querySelector('[data-treatment-counter]');

      if (slides.length < 2) return;

      let gi = 0;
      const show = (i) => {
        gi = (i + slides.length) % slides.length;
        slides.forEach((s, si) => {
          const active = si === gi;
          s.classList.toggle('is-active', active);
          if (active) s.removeAttribute('hidden'); else s.setAttribute('hidden', '');
        });
        thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === gi));
        if (counter) counter.textContent = (gi + 1) + ' / ' + slides.length;
      };

      galleryPrev && galleryPrev.addEventListener('click', () => show(gi - 1));
      galleryNext && galleryNext.addEventListener('click', () => show(gi + 1));
      thumbs.forEach((t, ti) => t.addEventListener('click', () => show(ti)));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-voucher"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const forms = document.querySelectorAll('[data-voucher-form]');
    forms.forEach((form) => {
      const idInput = form.querySelector('[data-voucher-id]');
      const priceEl = form.querySelector('[data-voucher-price]');
      const radios = Array.from(form.querySelectorAll('.product-voucher__amount-input'));
      if (!idInput || !radios.length) return;

      const sync = () => {
        const selected = radios.find((r) => r.checked);
        if (!selected) return;
        idInput.value = selected.value;
        if (priceEl && selected.dataset.priceFormatted) {
          priceEl.textContent = selected.dataset.priceFormatted;
        }
      };

      radios.forEach((r) => r.addEventListener('change', sync));
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
